import * as React from 'react';

import * as componentStyle from './PendingStateStyle.module.scss';
import * as style from '../../../../CelsiusClaimPageStyles.module.scss'

export const PendingState = () => (
  <div className={componentStyle.wrapper}>
    <h1 className={style.headerTitle}>We are processing your request</h1>
    <p className={style.headerText}>
    We are processing your request, you will be notified soon when your account can be imported
    </p>
  </div>
);